export const blockIconsTextformattingFeedNew = (
	<span className='material-symbols-outlined'>feed</span>
);
